import { Injectable } from '@angular/core';
import { AvailabilityFacade } from '@vi-succ/availability';
import { ProductsFacade } from '@vi-succ/products-domain';
import { SearchSparepartsFacade } from '@vi-succ/sparepart-domain';
import { PriceFacade } from '@vi-succ/util-prices';

@Injectable({
  providedIn: 'root',
})
export class EtCacheService {
  constructor(
    private productsFacade: ProductsFacade,
    private availabilityFacade: AvailabilityFacade,
    private sparepartFacade: SearchSparepartsFacade,
    private priceFacade: PriceFacade
  ) {}

  clearCache() {
    this.productsFacade.clearCache();
    this.availabilityFacade.clearAvailabilities();
    this.sparepartFacade.clearCache();
    this.priceFacade.clearNetprices();
  }
}
